webpackJsonp([6],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _forgotPassword = __webpack_require__(172);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	function loginClick() {
	    (0, _jquery2['default'])('.login-toggle, .login-close').removeClass('open').off('click');
	    if ((0, _jquery2['default'])('.login').css('display') == "none") {
	        (0, _jquery2['default'])('.login-toggle, .login-close').on('click', function (e) {
	            e.preventDefault();
	            (0, _jquery2['default'])('.login').toggleClass('open');
	        });
	    } else {
	        (0, _jquery2['default'])('.login-toggle, .login-close').removeClass('open').off('click');
	    }
	}
	
	// Smooth anchor scrolling
	function goToByScroll(id) {
	    (0, _jquery2['default'])('html,body').animate({ scrollTop: (0, _jquery2['default'])("#" + id).offset().top - 100 }, 1500);
	}
	
	// Add margin when alert is open
	function checkProgressView() {
	    var activateClick = false;
	
	    if ((0, _jquery2['default'])('.secondary-section-content').css('display') == "none") {
	        activateClick = true;
	    } else {
	        activateClick = false;
	    }
	
	    return activateClick;
	}
	
	function progressClick() {
	    (0, _jquery2['default'])('.secondary-section').removeClass('open').off('click');
	
	    var activateClick = checkProgressView();
	
	    if (activateClick) {
	        (0, _jquery2['default'])('.secondary-section').on('click', function () {
	            (0, _jquery2['default'])(this).toggleClass('open');
	        });
	    } else if (!activateClick) {
	        (0, _jquery2['default'])('.secondary-section').removeClass('open').off('click');
	    }
	}
	
	/*
	 If the banner is present, the page needs to be adjusted down to accomodate
	 */
	function adjustPageForAlert() {
	    var alertElem = '.page-alert';
	    var alertHeight = (0, _jquery2['default'])(alertElem).outerHeight();
	    (0, _jquery2['default'])('#page-header, .content-wrap').css('margin-top', alertHeight);
	}
	
	/**
	 * When the logged in SSO account is not associated with a student account,
	 * below function will show the Username-notfound-modal modal.
	 */
	function showUserNameNotFoundModal() {
	    if (window.userNameNotFound) {
	        (0, _jquery2['default'])("#Username-notfound-modal").modal('show');
	    }
	}
	
	/**
	 When the SSO account is not associated with a student account, user
	 is logged out and taken to the SSO login page.
	 */
	function logoutAndShowLoginFormWhenClicked() {
	    (0, _jquery2['default'])('#Username-notfound-modal').on('hide.bs.modal', function () {
	        (0, _jquery2['default'])("#non-student-log-out-form").submit();
	    });
	}
	
	document.addEventListener("DOMContentLoaded", function () {
	
	    // Jump button
	    (0, _jquery2['default'])('.jump-btn').on('click', function (e) {
	        e.preventDefault();
	        goToByScroll('start');
	    });
	
	    // Account creation mobile toggle
	    progressClick();
	    (0, _jquery2['default'])(window).resize(function () {
	        progressClick();
	    });
	
	    // Page alert
	    if ((0, _jquery2['default'])('body').hasClass('alert-open')) {
	
	        window.setTimeout(adjustPageForAlert, 200);
	
	        (0, _jquery2['default'])(window).resize(function () {
	            adjustPageForAlert();
	        });
	    }
	
	    // Login dropdown
	    loginClick();
	    (0, _jquery2['default'])(window).resize(function () {
	        loginClick();
	    });
	
	    showUserNameNotFoundModal();
	    logoutAndShowLoginFormWhenClicked();
	
	    // 2023_02_08: User should be taken to the SSO Reset Password page.
	    //ForgotPassword.init('#forgot-password-modal', '#forgot-password', '#forgot-password-modal-has-code');
	});

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _sweetalert = __webpack_require__(5);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _commonMessages = __webpack_require__(6);
	
	var _commonMessages2 = _interopRequireDefault(_commonMessages);
	
	var _endpointsAccountChangeRequestService = __webpack_require__(18);
	
	var _endpointsAccountChangeRequestService2 = _interopRequireDefault(_endpointsAccountChangeRequestService);
	
	var _commonNavigation = __webpack_require__(11);
	
	var _commonNavigation2 = _interopRequireDefault(_commonNavigation);
	
	var _commonValidators = __webpack_require__(13);
	
	_commonValidators.securityCode.addMethod();
	
	exports['default'] = {
	    init: function init(forgotModalSelector, clickSelector, forgoModalForHasCodeSelector) {
	        var forgotPwdModal = new ForgotPasswordModal(forgotModalSelector, clickSelector);
	        forgotPwdModal.init();
	
	        this.modalForHasCode = new ForgotPasswordModalForOnLoad(forgoModalForHasCodeSelector);
	        this.modalForHasCode.init();
	
	        if (window.location.search.indexOf('forgotPassword') >= 0) {
	            this.modalForHasCode.show();
	            window.history.replaceState({}, window.title, window.location.pathname);
	        }
	    }
	};
	
	var AbstractModal = (function () {
	    function AbstractModal(modalSelector) {
	        _classCallCheck(this, AbstractModal);
	
	        this.modal = (0, _jquery2['default'])(modalSelector);
	        this.theForm = this.modal.find('form');
	    }
	
	    _createClass(AbstractModal, [{
	        key: 'init',
	        value: function init(onValidated) {
	            var _this = this;
	
	            //clear specified inputs when modal is shown
	            this.modal.off('show.bs.modal').on('show.bs.modal', function () {
	                _this.modal.find('label.error').remove();
	                _this.modal.find('.error').removeClass("error");
	
	                _this.modal.find('input:not(.no-validate)').val('').trigger('change');
	            });
	            //set first input active after opening
	            this.modal.off('shown.bs.modal').on('shown.bs.modal', function () {
	                _this.modal.find('input').filter(':first').trigger('focus');
	            });
	
	            this.modal.off('click', '.btn-save').on('click', '.btn-save', function (e) {
	                e.preventDefault();
	                _this.theForm.submit();
	            });
	
	            this.theForm.off('submit').on('submit', function (e) {
	                e.preventDefault();
	                if (_this.theForm.valid() === true) {
	                    onValidated(_this.theForm);
	                }
	            });
	
	            this.theForm.validate();
	        }
	    }]);
	
	    return AbstractModal;
	})();
	
	var ForgotPasswordModal = (function (_AbstractModal) {
	    _inherits(ForgotPasswordModal, _AbstractModal);
	
	    function ForgotPasswordModal(modalSelector, clickSelector) {
	        var _this2 = this;
	
	        _classCallCheck(this, ForgotPasswordModal);
	
	        _get(Object.getPrototypeOf(ForgotPasswordModal.prototype), 'constructor', this).call(this, modalSelector);
	        (0, _jquery2['default'])(clickSelector).on('click', function () {
	            return _this2.modal.appendTo("body").modal({ 'show': true, backdrop: 'static' });
	        });
	        var confirmModalSelector = this.modal.data('next-step-id');
	        this.nextStep = new ConfirmEmailModal((0, _jquery2['default'])('#' + confirmModalSelector));
	    }
	
	    _createClass(ForgotPasswordModal, [{
	        key: 'init',
	        value: function init() {
	            var _this3 = this;
	
	            _get(Object.getPrototypeOf(ForgotPasswordModal.prototype), 'init', this).call(this, function (theForm) {
	                return _this3['continue'](theForm.find(".required.email").val());
	            });
	        }
	    }, {
	        key: 'continue',
	        value: function _continue(address) {
	            var _this4 = this;
	
	            _endpointsAccountChangeRequestService2['default'].requestPasswordReset(new _endpointsAccountChangeRequestService.StudentAccountChangeRequest(address)).then(function () {
	                _this4.modal.modal('hide');
	                _this4.nextStep.init(address);
	                _this4.nextStep.show();
	            })['catch'](function (error) {
	                (0, _sweetalert2['default'])({
	                    title: "Error",
	                    text: 'We were unable to send your password reset code. ' + _commonMessages2['default'].CONTACT_SUPPORT,
	                    type: "error",
	                    confirmButtonText: "Ok" });
	            });
	            return this.nextStep;
	        }
	    }]);
	
	    return ForgotPasswordModal;
	})(AbstractModal);
	
	var ForgotPasswordModalForOnLoad = (function (_AbstractModal2) {
	    _inherits(ForgotPasswordModalForOnLoad, _AbstractModal2);
	
	    function ForgotPasswordModalForOnLoad(modalSelector) {
	        _classCallCheck(this, ForgotPasswordModalForOnLoad);
	
	        _get(Object.getPrototypeOf(ForgotPasswordModalForOnLoad.prototype), 'constructor', this).call(this, modalSelector);
	        var confirmModalSelector = this.modal.data('next-step-id');
	        this.nextStep = new ConfirmEmailModal((0, _jquery2['default'])('#' + confirmModalSelector));
	    }
	
	    _createClass(ForgotPasswordModalForOnLoad, [{
	        key: 'init',
	        value: function init() {
	            var _this5 = this;
	
	            _get(Object.getPrototypeOf(ForgotPasswordModalForOnLoad.prototype), 'init', this).call(this, function (theForm) {
	                return _this5['continue'](theForm.find(".required.email").val());
	            });
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            this.modal.appendTo("body").modal({ 'show': true, backdrop: 'static' });
	        }
	    }, {
	        key: 'continue',
	        value: function _continue(address) {
	
	            this.modal.modal('hide');
	            this.nextStep.init(address);
	            this.nextStep.show();
	
	            return this.nextStep;
	        }
	    }]);
	
	    return ForgotPasswordModalForOnLoad;
	})(AbstractModal);
	
	var ConfirmEmailModal = (function (_AbstractModal3) {
	    _inherits(ConfirmEmailModal, _AbstractModal3);
	
	    function ConfirmEmailModal(modalSelector) {
	        _classCallCheck(this, ConfirmEmailModal);
	
	        _get(Object.getPrototypeOf(ConfirmEmailModal.prototype), 'constructor', this).call(this, modalSelector);
	        var changeModalSelector = this.modal.data('next-step-id');
	        this.nextStep = new ChangePasswordModal((0, _jquery2['default'])('#' + changeModalSelector));
	    }
	
	    _createClass(ConfirmEmailModal, [{
	        key: 'continue',
	        value: function _continue(address, code) {
	            this.nextStep.init(address, code);
	            this.next();
	
	            return this.nextStep;
	        }
	    }, {
	        key: 'init',
	        value: function init(email) {
	            var _this6 = this;
	
	            var emailText = this.modal.find('#replace-email-text');
	            if (emailText) {
	                emailText.text(emailText.text().replace('{{{email}}}', email));
	            }
	
	            _get(Object.getPrototypeOf(ConfirmEmailModal.prototype), 'init', this).call(this, function (theForm) {
	                var verificationCode = theForm.find("#confirm-email-verification-code").val();
	                _this6['continue'](email, verificationCode);
	            });
	
	            this.theForm.find('#confirm-email-modal-emailAddress').val(email);
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            this.modal.appendTo("body").modal('show');
	        }
	    }, {
	        key: 'next',
	        value: function next() {
	            this.modal.modal('hide');
	            this.nextStep.show();
	        }
	    }]);
	
	    return ConfirmEmailModal;
	})(AbstractModal);
	
	var ChangePasswordModal = (function (_AbstractModal4) {
	    _inherits(ChangePasswordModal, _AbstractModal4);
	
	    function ChangePasswordModal(modalSelector) {
	        _classCallCheck(this, ChangePasswordModal);
	
	        _get(Object.getPrototypeOf(ChangePasswordModal.prototype), 'constructor', this).call(this, modalSelector);
	    }
	
	    _createClass(ChangePasswordModal, [{
	        key: 'continue',
	        value: function _continue(email, securityCode, newPassword) {
	            var change = { email: email, securityCode: securityCode, newPassword: newPassword };
	            _endpointsAccountChangeRequestService2['default'].performChange(change).then(function () {
	                return _commonNavigation2['default'].goto('dashboard?passwordChanged');
	            })['catch'](function (error) {
	                (0, _sweetalert2['default'])({
	                    title: "Error",
	                    text: 'We were unable to change your password. ' + _commonMessages2['default'].CONTACT_SUPPORT,
	                    type: "error",
	                    confirmButtonText: "Ok" });
	            });
	        }
	    }, {
	        key: 'init',
	        value: function init(email, code) {
	            var _this7 = this;
	
	            this.theForm.validate({
	                rules: {
	                    'edit-password-confirm': {
	                        'equalTo': '#edit-password'
	                    }
	                },
	                messages: {
	                    'edit-password-confirm': {
	                        'equalTo': 'passwords must match'
	                    }
	                }
	            });
	            _get(Object.getPrototypeOf(ChangePasswordModal.prototype), 'init', this).call(this, function (theForm) {
	                var newPassword = theForm.find("#edit-password").val();
	                _this7['continue'](email, code, newPassword);
	            });
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            this.modal.appendTo("body").modal('show');
	        }
	    }]);
	
	    return ChangePasswordModal;
	})(AbstractModal);
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// index-page.js